import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { Agencies } from 'app/models/agencies';
import { AgenciesService } from 'app/services/agencies/agencies.service';
import { PrimeNGConfig } from 'primeng/api';

import { SearchService } from 'app/services/search/search.service';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-promoteurs-sousse',
  templateUrl: './promoteurs-sousse.component.html',
  styleUrls: ['./promoteurs-sousse.component.scss']
})
export class PromoteursSousseComponent implements OnInit {
  public agenciesSousse: any
  public lengthBoutique:any
  public testArraySort: any
  responsiveOptions
  @ViewChild('agencyForm', { static: false })
  agencyForm: NgForm;
  p: Number = 1;
  agenciedData: Agencies;
  dataSource = new MatTableDataSource();
  displayedColumns: string[];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  isEditMode = false;
  public agencies:any
  public idAgency: any
  closeResult = '';
  search_name1:any;
  public Agency: any
  public search: string  = ''
  pageIndex:number = 0;
  pageSize:number = 50;
  lowValue:number = 0;
  highValue:number = 50; 
  lengthSociete=10;
  totalSociete : any;
  arrays: any[] = [];
  tempArray: any[] = [];
  newArray: any[] = []
  constructor(private agencieService: AgenciesService,
    private primengConfig: PrimeNGConfig,private router: Router,
    private searchService: SearchService) { }

  getData() {
    this.agencieService.getListPromoteur().subscribe((data: any) => {
      console.log(data);
      this.agencies = data.filter((promoteur: any) => promoteur.region === 'Sousse');
      this.totalSociete = this.agencies.length;
      console.log("Liste des promoteurs en Sousse :", this.agencies);
    });
  }

  ngOnInit(): void {
    this.agencieService.refreshNeeded.subscribe(() => this.getData());
    this.primengConfig.ripple = true;

this.getagencesSousse();

    
  }
  getagencesSousse() {
    this.agencieService.getAgencieSousse().subscribe((data: any) => {
      this.agenciesSousse = data;
      console.log("liste des agences a sousse ", this.agenciesSousse);
      // Filtrer les promoteurs de Tunis
      this.agencies = this.agenciesSousse
      .sort((a: any, b: any) => {
        // Sort based on the existence of projets array
        if (a.projets.length === 0 && b.projets.length > 0) {
          return 1; // Move agencie with empty projets to the end
        } else if (a.projets.length > 0 && b.projets.length === 0) {
          return -1; // Move agencie with non-empty projets to the beginning
        } else {
          return 0; // No change in order
        }
      });
        
    });
  }
ngAfterViewInit() {
  this.agencieService.refreshNeeded.subscribe(() => this.getData());
  this.getData()
}


cancelEdit() {
  this.isEditMode = false;
  this.agencyForm.resetForm();
}

deleteAgencies(agencie,i) {
  Swal.fire({
    title: "Êtes-vous sûr(e) ?",
    text: "Vous ne pourrez pas revenir en arrière !",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Oui, supprimez-le."
  }).then((result) => {
    if (result.isConfirmed) {
      this.agencieService.deleteItem(agencie.id).subscribe((response: any) => {
        console.log(this.dataSource.data);
        // this.AgenciesTunis.splice(i,1)

        // If you want to show a success message after the deletion, use another Swal.fire here
        Swal.fire({
          title: "Supprimé!",
          text: "Votre agence a été supprimée.",
          icon: "success"
        });
        // Fetch the updated data after deletion
       
      }); setTimeout(() => {
          this.getagencesSousse();
        }, 500);
      
    }
  });
}
public changePage(){
  this.lengthSociete=this.lengthSociete+10;
}
 // Méthode pour effectuer la recherche
 performSearch() {
  this.agenciesSousse = this.searchService.search(this.agenciesSousse, this.search);
}
}